
export default function Location() {
    return (
        <>
            <div className="location text-center"
                width='60vw'

            >
                <h3 className='even pb-4'>I&#8217;m From</h3>

                <iframe
                    height='50%'
                    width='60%'
                    title="Location"
                    src="https://maps.google.com/maps?width=85%25&amp;height=250px&amp;hl=en&amp;q=Gurusamipalayam,%20Tamil%20Nadu,%20637403+(Balaji%20Home)&amp;t=&amp;z=5&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>

            </div>


            <br />
            <br />
            <br />
            <br />
            <br />
        </>
    )
}